export default {
	tenantId: "coverHealth_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "coverhealth--uat"
	}
}
